import {
    X,
} from "lucide-preact";

type TagPillProps = {
    tag: string;
    onRemove?: () => void;
    onClick?: () => void;
    size?: "sm" | "md";
    showRemove?: boolean;
};

export const TagPill = ({
    tag,
    onRemove,
    onClick,
    size = "md",
    showRemove = false,
}: TagPillProps) => {
    const sizeClasses = size === "sm"
        ? "px-1.5 py-0.5 text-xs"
        : "px-2 py-1 text-sm";

    const colorClasses = "bg-accent/20 text-accent border-accent/30";

    return (
        <span
            className={`
        inline-flex items-center gap-1 rounded border
        ${sizeClasses}
        ${colorClasses}
        ${onClick ? "cursor-pointer hover:opacity-80" : ""}
        transition-opacity
      `}
            onClick={onClick}
        >
            {tag}
            {showRemove && onRemove && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    className="hover:opacity-70 transition-opacity"
                >
                    <X size={size === "sm" ? 12 : 14} />
                </button>
            )}
        </span>
    );
};
